module.exports = __webpack_public_path__ + "static/media/TikTokFont-Regular.5898608c.ttf";